import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

// Retrieve the Tracking ID from environment variables
const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

// Initialize GA once when the app loads, only in production
if (process.env.NODE_ENV === "production" && GA_TRACKING_ID) {
  try {
    ReactGA.initialize(GA_TRACKING_ID);
    console.log("Google Analytics initialized with ID:", GA_TRACKING_ID);
  } catch (error) {
    console.error("Failed to initialize Google Analytics:", error);
  }
} else if (process.env.NODE_ENV === "production" && !GA_TRACKING_ID) {
  console.warn("Google Analytics Tracking ID is missing. GA will not be initialized.");
}

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Send pageview on route change, only in production and if initialized
    if (process.env.NODE_ENV === "production" && ReactGA.isInitialized) {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
        title: document.title // Optionally send the document title
      });
      console.log(`GA Pageview sent: ${location.pathname + location.search}`);
    }
  }, [location]);

  return null; // This component does not render anything
};

export default RouteChangeTracker;